import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { MdCameraAlt, MdAdd } from 'react-icons/md';
import TokenInput from 'react-customize-token-input';
import 'react-customize-token-input/dist/react-customize-token-input.css';
import { FaChevronCircleDown, FaChevronCircleUp } from 'react-icons/fa';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
// Importando o componente
import Modal from '~/components/Modal';
import Table from '~/components/Table';
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Select from '~/components/Form/Select';
import Textarea from '~/components/Form/Textarea';
import Load from '~/components/Load';

import {
  Container,
  Wrapper,
  Ward,
  ImagemInput,
  BoxImagem,
  Imagem,
  ModalBody,
  ModalMenus,
  Menus,
  NewButton,
  Etapas,
  FormInner,
  EtapasInner,
  EtapasHead,
  EtapasTop,
  EtapasInput,
  EtapasImg,
} from './styles';

export default function ProductEdit({ match }) {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);
  const [dado, setDado] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [cidadeSelect, setCidadeSelect] = useState([]);
  const [incorporadoras, setIncorporadoras] = useState([]);
  const [incorporadoraSelect, setIncorporadoraSelect] = useState([]);
  const [cadencias, setCadencias] = useState([]);
  const [cadenciaSelect, setCadenciaSelect] = useState([]);
  const [times, setTimes] = useState([]);
  const [timeSelect, setTimeSelect] = useState([]);
  const [integracoes, setIntegracoes] = useState([]);
  const [integracaoSelect, setIntegracaoSelect] = useState([]);
  const [imagens, setImagens] = useState([]);
  const [imagemSelect, setImagemSelect] = useState('');
  const [perguntas, setPerguntas] = useState([]);

  const [idProduto, setIdProduto] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [padraos, setPadraos] = useState([]);
  const [visibleCrm, setVisibleCrm] = useState(false);
  const [whatsapp, setWhatsapp] = useState([]);
  const [whatsappSelect, setWhatsappSelect] = useState([]);

  const [etapa1, setEtapa1] = useState(true);
  const [etapa2, setEtapa2] = useState(true);
  const [etapa4, setEtapa4] = useState(true);
  const [etapa5, setEtapa5] = useState(true);

  const [padraoDefault, setPadraoDefault] = useState([]);

  const user = useSelector(state => state.user.profile);

  // Pegando os padroes
  const getPadrao = useCallback(async () => {
    if (padraos.length === 0) {
      const { id } = match.params;
      const responsePadrao = await api.get(`/produto/${id}/padrao`);

      responsePadrao.data.map(item => {
        const { name } = item;
        return setPadraoDefault(padrao => [...padrao, name]);
      });
    }
    setLoading(false);
  }, [match.params, padraos]);

  // Pegandos os dados do produtos
  const getProduto = useCallback(async () => {
    try {
      setLoading(true);
      // Pegando dados do produto
      const { id } = match.params;
      const responseProduto = await api.get(`/produtos/${id}`);

      if (
        responseProduto.data.integracao &&
        responseProduto.data.integracao.name ===
          'Facilita - Penta Incorporadora'
      ) {
        setVisibleCrm(true);
      } else {
        setVisibleCrm(false);
      }

      // Pegando dados da cidade
      const responseCidade = await api.get('/cidades');
      const dataCidade = responseCidade.data.map(cidade => ({
        value: cidade.id,
        label: cidade.name,
      }));

      const dataCidadeSelect = dataCidade.filter(cidade => {
        return cidade.value === responseProduto.data.cidade_id;
      });

      // Verificando se é usuario bamboo e buscando incorporadoras
      if (user.provider === '4') {
        const responseIncorporadora = await api.get('/incorporadora');
        const dataIncorporadora = responseIncorporadora.data.map(inc => ({
          value: inc.id,
          label: inc.name,
        }));

        const dataIncorporadoraSelect = dataIncorporadora.filter(
          incorporadora => {
            return (
              incorporadora.value === responseProduto.data.incorporadora_id
            );
          }
        );

        setIncorporadoras(dataIncorporadora);
        setIncorporadoraSelect(dataIncorporadoraSelect[0]);
      }

      // Pegando o time
      const responseTime = await api.get('/times-select');

      const dataTime = responseTime.data.map(time => ({
        value: time.id,
        label: time.name,
      }));

      const dataTimeSelect = dataTime.filter(time => {
        return time.value === responseProduto.data.time_id;
      });

      // Pegando a cadencia
      const responseCadencia = await api.get('/cadencia');
      const dataCadencia = responseCadencia.data.map(ca => ({
        value: ca.id,
        label: ca.name,
      }));

      const dataCadenciaSelect = dataCadencia.filter(cadencia => {
        return cadencia.value === responseProduto.data.cadencia_id;
      });

      // Pegando a integracao
      const responseIntegracao = await api.get('/integracao');
      const dataIntegracao = responseIntegracao.data.map(int => ({
        value: int.id,
        label: int.name,
      }));

      const dataIntegracaoSelect = dataIntegracao.filter(integracao => {
        return integracao.value === responseProduto.data.integracao_id;
      });

      const responseWhatsapp = await api.get('/whatsapp');

      const dataWhatsapp = responseWhatsapp.data.map(what => {
        return {
          value: what.id,
          label: what.name,
        };
      });

      const dataWhatsappSelect = dataWhatsapp.filter(what => {
        return what.value === responseProduto.data.whatsapp_id;
      });

      if (responseProduto.data.padrao) {
        setPadraos(responseProduto.data.padrao);
      }

      setIdProduto(responseProduto.data.id);
      setDado(responseProduto.data);
      setCidades(dataCidade);
      setCidadeSelect(dataCidadeSelect[0]);
      setTimes(dataTime);
      setTimeSelect(dataTimeSelect[0]);
      setCadencias(dataCadencia);
      setCadenciaSelect(dataCadenciaSelect[0]);
      setIntegracoes(dataIntegracao);
      setIntegracaoSelect(dataIntegracaoSelect[0]);
      setImagens(responseProduto.data.files);
      setWhatsapp(dataWhatsapp);
      setWhatsappSelect(dataWhatsappSelect[0]);
      setLoading(false);
    } catch (error) {
      toast.error('Erro no servidor, aguarde que será corrigido.');
      history.push('/produto');
    }
  }, [match.params, user.provider]);

  // Pegando as perguntas
  const getPerguntas = useCallback(async () => {
    const { id } = match.params;

    const responsePerguntas = await api.get(`/produto/${id}/perguntas`);

    const data = responsePerguntas.data.map(pergunta => {
      return {
        ...pergunta,
        statusFormat: pergunta.status === '1' ? 'Ativo' : 'Inativo',
      };
    });

    setPerguntas(data);
  }, [match.params]);

  useEffect(() => {
    getProduto();
    getPerguntas();
    getPadrao();
  }, [getPerguntas, getProduto, getPadrao]);

  function handleTokensUpdate(tokens) {
    const token = tokens.map(tok => {
      return tok.value;
    });
    setPadraoDefault(token);
  }

  // Edicao do produto
  async function hanlderEditarProduto(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});

      let schema;

      if (user.provider === '4') {
        schema = Yup.object().shape({
          cidade_id:
            cidadeSelect === []
              ? Yup.string('Selecione uma cidade').required(
                  'Selecione uma cidade'
                )
              : null,
          cadencia_id:
            cadenciaSelect === []
              ? Yup.string('Selecione uma cadencia').required(
                  'Selecione uma cadencia'
                )
              : null,
          whatsapp_id:
            !whatsappSelect || whatsappSelect === []
              ? Yup.string('Selecione uma integração de mensagem').required(
                  'Selecione uma integração de mensagem'
                )
              : null,
          integracao_id:
            integracaoSelect === []
              ? Yup.string('Selecione uma integração').required(
                  'Selecione uma integração'
                )
              : null,
          incorporadora_id:
            incorporadoraSelect === []
              ? Yup.string('Selecione uma incorporadora').required(
                  'Selecione uma incorporadora'
                )
              : null,
          time_id:
            timeSelect === []
              ? Yup.string('Selecione um time').required('Selecione um time')
              : null,
          name: Yup.string().required('Preencha o campo nome'),
          description: Yup.string().required('Preencha o campo descrição'),
          chamada: Yup.string().required('Preencha o campo chamada'),
          crm_id: visibleCrm
            ? Yup.string().required('Preencha o campo Id do crm do produto')
            : null,
        });
      } else {
        schema = Yup.object().shape({
          cidade_id:
            cidadeSelect === []
              ? Yup.string('Selecione uma cidade').required(
                  'Selecione uma cidade'
                )
              : null,
          cadencia_id:
            cadenciaSelect === []
              ? Yup.string('Selecione uma cadencia').required(
                  'Selecione uma cadencia'
                )
              : null,
          whatsapp_id:
            whatsappSelect === []
              ? Yup.string('Selecione uma integração de mensagem').required(
                  'Selecione uma integração de mensagem'
                )
              : null,
          integracao_id:
            integracaoSelect === []
              ? Yup.string('Selecione uma integração').required(
                  'Selecione uma integração'
                )
              : null,
          time_id:
            timeSelect === []
              ? Yup.string('Selecione um time').required('Selecione um time')
              : null,
          name: Yup.string().required('Preencha o campo nome'),
          description: Yup.string().required('Preencha o campo descrição'),
          chamada: Yup.string().required('Preencha o campo chamada'),
          crm_id: visibleCrm
            ? Yup.string().required('Preencha o campo Id do crm do produto')
            : null,
        });
      }

      await schema.validate(data, {
        abortEarly: false,
      });

      const incorporadora =
        user.provider === '4'
          ? incorporadoraSelect === []
            ? data.incorporadora_id
            : incorporadoraSelect.value
          : user.time.incorporadora_id;

      const padroes = padraoDefault.map((pads)=>({name: pads}));

      //SALVANDO PADRAO EM FORMATO DE ARRAY COM NOMES
      await api.post(`/produto-padrao/${dado.id}`,{
        padroes
      })

      await api.put(`/produtos/${dado.id}`, {
        cidade_id: cidadeSelect === [] ? data.cidade_id : cidadeSelect.value,
        cadencia_id:
          cadenciaSelect === [] ? data.cadencia_id : cadenciaSelect.value,
        integracao_id:
          integracaoSelect === [] ? data.integracao_id : integracaoSelect.value,
        incorporadora_id: incorporadora,
        time_id: timeSelect === [] ? data.time_id : timeSelect.value,
        name: data.name,
        description: data.description,
        chamada: data.chamada,
        crm_id: visibleCrm ? data.crm_id : null,
        whatsapp_id:
          whatsappSelect === [] ? data.whatsapp_id : whatsappSelect.value,
      });

      toast.success('Produto editado com sucesso');
      getProduto();
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao editar produto, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  // Sistema de imagens
  async function handlerImagem(e) {
    try {
      setLoading(true);
      const { id } = match.params;
      const data = new FormData();
      data.append('file', e.target.files[0]);
      await api.post(`/files?produto_id=${id}`, data);
      getProduto();
      toast.success('Upload feito com sucesso');
    } catch (error) {
      setLoading(true);
      toast.error('Erro ao fazer upload da imagem');
    }
  }

  async function handlerDeleteImagem() {
    try {
      setLoading(true);
      const { id } = match.params;
      await api.delete(`/files/${imagemSelect}?produto_id=${id}`);
      const dataImagens = imagens.filter(imagem => {
        return imagem.name !== imagemSelect;
      });
      setImagens(dataImagens);
      toast.success('Imagem deletada com sucesso');
    } catch (error) {
      setLoading(true);
      toast.error('Erro ao deletar imagem');
    } finally {
      setLoading(false);
      setIsVisible(false);
    }
  }

  function openModal(name) {
    setIsVisible(true);
    setImagemSelect(name);
  }

  function closeModal() {
    setIsVisible(false);
  }

  // Sistema do questionario

  function handlerQuestionarioCreate() {
    history.push(`/questionario-create/${idProduto}`);
  }

  async function handlerEditarQuest(id) {
    history.push(`/questionario-edit/${idProduto}/quizzes/${id}`);
  }

  async function handlerDeleteQuest(number) {
    try {
      if (number.length > 1) {
        const res = number.map(async num => {
          const response = await api.delete(
            `/produto/${idProduto}/perguntas/${num}`
          );
          return response.data;
        });
        const tr = Promise.all(res);
        const df = Promise.resolve(tr);
        df.then(result => {
          if (result[0] !== undefined) {
            toast.success('Questionário ativado/desativado com sucesso');
            getPerguntas();
          }
        });
      } else {
        const response = await api.delete(
          `/produto/${idProduto}/perguntas/${number}`
        );

        if (response.data) {
          toast.success('Questionário ativado/desativado com sucesso');
          getPerguntas();
        }
      }
    } catch (error) {
      toast.error('Erro ao ativado/desativado questionário');
      // getQuestionarios();
    }
  }

  // Criando dados da coluna
  const columnsQuestionario = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Nome',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'pergunta',
      label: 'Pergunta',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'statusFormat',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
      },
    },
  ];
  // const columnsMensagem = [
  //   {
  //     name: 'id',
  //     label: 'Id',
  //     options: {
  //       filter: false,
  //       sort: true,
  //       display: false,
  //     },
  //   },
  //   {
  //     name: 'corpo',
  //     label: 'Mensagem',
  //     options: {
  //       filter: false,
  //       sort: false,
  //     },
  //   },
  //   {
  //     name: 'active',
  //     label: 'Apos horario de expediente',
  //     options: {
  //       filter: false,
  //       sort: false,
  //     },
  //   },
  // ];

  async function handleIntegracao(e) {
    setIntegracaoSelect(e);
    if (e.label !== 'RealizaApp') {
      setVisibleCrm(true);
    } else {
      setVisibleCrm(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <>
      <Container>
        <h4>Editar Produto</h4>
        <Wrapper>
          <Form
            ref={inputRef}
            initialData={dado}
            onKeyUp={e => {
              if (e.keyCode === 13) {
                e.preventDefault();
              }
            }}
            onSubmit={hanlderEditarProduto}
            autoComplete="off"
            style={{ width: '100%' }}
          >
            <FormInner>
              <Etapas>
                <Card>
                  <EtapasHead
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setEtapa1(!etapa1);
                    }}
                  >
                    <p>
                      Primeira etapa: <br />
                      Descrição do produto.
                    </p>
                    {etapa1 ? (
                      <FaChevronCircleDown size="20" />
                    ) : (
                      <FaChevronCircleUp size="20" />
                    )}
                  </EtapasHead>
                  <EtapasInner column show={etapa1}>
                    <EtapasTop>
                      <EtapasInput>
                        <Input
                          icon="MdPerson"
                          label="Nome"
                          name="name"
                          type="text"
                        />
                        <Input
                          icon="MdFeaturedVideo"
                          label="Chamada do produto"
                          name="chamada"
                          type="text"
                        />
                      </EtapasInput>
                      <EtapasImg>
                        {loading ? (
                          <Load />
                        ) : (
                          <Ward>
                            {imagens.map(imga => (
                              <Imagem
                                key={imga.id}
                                onClick={() => openModal(imga.name)}
                              >
                                <img src={imga.url} alt={imga.name} />
                              </Imagem>
                            ))}

                            <ImagemInput htmlFor="imagem" size={imagens.length}>
                              <BoxImagem>
                                <MdCameraAlt size={60} color="#FFF" />
                              </BoxImagem>
                              <input
                                type="file"
                                accept="image/*"
                                id="imagem"
                                disabled={imagens.length >= 6}
                                onChange={handlerImagem}
                              />
                            </ImagemInput>
                          </Ward>
                        )}
                      </EtapasImg>
                    </EtapasTop>
                    <Textarea label="Descrição" name="description" />
                  </EtapasInner>
                </Card>
                <Button tamanho="40px" load={carregar}>
                  Salvar Produto
                </Button>
              </Etapas>

              <Etapas>
                <Card>
                  <EtapasHead
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setEtapa2(!etapa2);
                    }}
                  >
                    <p>
                      Segunda etapa: <br />
                      Informações do produto.
                    </p>
                    {etapa2 ? (
                      <FaChevronCircleDown size="20" />
                    ) : (
                      <FaChevronCircleUp size="20" />
                    )}
                  </EtapasHead>
                  <EtapasInner show={etapa2}>
                    <Select
                      size
                      name="cidade_id"
                      labelSelect="Cidade"
                      options={cidades}
                      defaultValue={cidadeSelect}
                      onChange={e => setCidadeSelect(e)}
                    />
                    {user.provider === '4' && (
                      <Select
                        size
                        name="incorporadora_id"
                        labelSelect="Incorporadora"
                        options={incorporadoras}
                        defaultValue={incorporadoraSelect}
                        onChange={e => setIncorporadoraSelect(e)}
                      />
                    )}

                    <Select
                      size
                      name="time_id"
                      labelSelect="Time"
                      options={times}
                      defaultValue={timeSelect}
                      onChange={e => setTimeSelect(e)}
                    />
                    <Select
                      size
                      name="cadencia_id"
                      labelSelect="Cadencia"
                      options={cadencias}
                      defaultValue={cadenciaSelect}
                      onChange={e => setCadenciaSelect(e)}
                    />
                  </EtapasInner>
                </Card>
                {user.provider === '4' && (
                  <Card>
                    <EtapasHead
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setEtapa5(!etapa5);
                      }}
                    >
                      <p>
                        Terceira etapa: <br />
                        Adicione os Padrões e Integrações do produto .
                      </p>
                      {etapa5 ? (
                        <FaChevronCircleDown size="20" />
                      ) : (
                        <FaChevronCircleUp size="20" />
                      )}
                    </EtapasHead>

                    <EtapasInner column show={etapa5}>
                      <TokenInput
                        style={{
                          background: '#2a3142',
                          width: '100%',
                          color: '#fff',
                        }}
                        defaultData={padraoDefault}
                        onTokensUpdate={e => {
                          handleTokensUpdate(e);
                        }}
                      />
                      <EtapasInner show>
                        <Select
                          size
                          name="integracao_id"
                          labelSelect="Integração"
                          options={integracoes}
                          defaultValue={integracaoSelect}
                          onChange={e => handleIntegracao(e)}
                        />
                        <Select
                          size
                          name="whatsapp_id"
                          labelSelect="Whatsapp"
                          options={whatsapp}
                          defaultValue={whatsappSelect}
                          onChange={e => setWhatsappSelect(e)}
                        />
                        {visibleCrm && (
                          <div
                            style={{
                              diplay: 'flex',
                              width: '50%',
                            }}
                          >
                            <Input
                              icon="MdAccountBalanceWallet"
                              label="Id do produto no crm"
                              name="crm_id"
                              type="number"
                            />
                          </div>
                        )}
                      </EtapasInner>
                    </EtapasInner>
                  </Card>
                )}
              </Etapas>
            </FormInner>
          </Form>
        </Wrapper>
        <h4>Questionários</h4>
        <Wrapper style={{ width: '100%' }}>
          <Card>
            <EtapasHead
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setEtapa4(!etapa4);
              }}
            >
              <p>
                Quarta etapa: <br />
                Escolha as perguntas à serem utilizadas no atendimento.
              </p>
              {etapa4 ? (
                <FaChevronCircleDown size="20" />
              ) : (
                <FaChevronCircleUp size="20" />
              )}
            </EtapasHead>

            <EtapasInner column show={etapa4}>
              <Menus>
                <NewButton type="button" onClick={handlerQuestionarioCreate}>
                  <MdAdd size={16} color="#FFF" />
                  Novo
                </NewButton>
              </Menus>
              <Table
                title="Integrações"
                data={perguntas}
                columns={columnsQuestionario}
                ds={handlerDeleteQuest}
                ed={handlerEditarQuest}
                messages="Você deseja ativar/desativar o(s) questionário(s) ?"
                st
              />
            </EtapasInner>
          </Card>
        </Wrapper>
      </Container>
      {isVisible && (
        <Modal>
          <ModalBody>
            <span>Você deseja excluír a imagem ?</span>
            <ModalMenus>
              <button type="button" onClick={handlerDeleteImagem}>
                Sim
              </button>
              <button type="button" onClick={closeModal}>
                Nao
              </button>
            </ModalMenus>
          </ModalBody>
        </Modal>
      )}
    </>
  );
}

ProductEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};
